export default "__VITE_ASSET__53w_$Aoe__"